module.exports = __webpack_public_path__ + "src/assets/games/42/21.jpg";